/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import React from "react";
import { Box } from "__barrel_optimize__?names=Box!=!@mui/material";
const defaultSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: "linear",
    appendDots: (dots)=>/*#__PURE__*/ _jsx("div", {
            style: {
                position: "relative",
                bottom: "70px"
            },
            children: /*#__PURE__*/ _jsxs("ul", {
                style: {
                    margin: "0px"
                },
                children: [
                    " ",
                    dots,
                    " "
                ]
            })
        })
};
export default function Carousel(param) {
    let { children, settings, sx } = param;
    const childrenArray = React.Children.toArray(children);
    const isSingleSlide = childrenArray.length === 1;
    var _settings_infinite, _settings_autoplay, _settings_dots;
    const adjustedSettings = {
        ...defaultSettings,
        ...settings,
        infinite: !isSingleSlide && ((_settings_infinite = settings === null || settings === void 0 ? void 0 : settings.infinite) !== null && _settings_infinite !== void 0 ? _settings_infinite : defaultSettings.infinite),
        autoplay: !isSingleSlide && ((_settings_autoplay = settings === null || settings === void 0 ? void 0 : settings.autoplay) !== null && _settings_autoplay !== void 0 ? _settings_autoplay : defaultSettings.autoplay),
        dots: !isSingleSlide && ((_settings_dots = settings === null || settings === void 0 ? void 0 : settings.dots) !== null && _settings_dots !== void 0 ? _settings_dots : defaultSettings.dots)
    };
    return /*#__PURE__*/ _jsx(Box, {
        sx: {
            width: "100%",
            maxWidth: "1400px",
            margin: "0 auto",
            ...sx
        },
        children: /*#__PURE__*/ _jsx(Slider, {
            ...adjustedSettings,
            children: children
        })
    });
}
